import { Columns3 } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { useOverlays } from './overlay-context';
import {
  COLUMN_LABELS,
  OPTIONAL_COLUMNS,
  type ColumnVisibility,
  type OptionalColumn,
} from './use-column-visibility';

type Props = {
  visible: ColumnVisibility;
  onChange: (column: OptionalColumn, next: boolean) => void;
};

export default function ColumnsMenu({ visible, onChange }: Props) {
  const { pushBlock, popBlock } = useOverlays();

  return (
    <DropdownMenu
      onOpenChange={(open) => {
        if (open) pushBlock();
        else popBlock();
      }}
    >
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="ghost" size="icon" className="h-8 w-8" aria-label="Columns">
          <Columns3 className="h-4 w-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-44">
        {OPTIONAL_COLUMNS.map((column) => (
          <DropdownMenuCheckboxItem
            key={column}
            checked={visible[column]}
            onCheckedChange={(checked) => onChange(column, checked === true)}
          >
            {COLUMN_LABELS[column]}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
